// A pinned illustration is useful only while a substantial amount of its
// accompanying text still needs to enter the viewport. Decide from layout,
// never scroll position, so the element cannot oscillate between modes.
export function shouldPinProjectMedia({ copyHeight, mediaHeight, viewportHeight, top = 84 }) {
  if (copyHeight <= 0 || mediaHeight <= 0 || viewportHeight <= 0) return false;
  const readingHeight = Math.max(0, viewportHeight - top - 24);
  const minimumTravel = Math.max(96, Math.min(160, readingHeight * .2));
  return copyHeight - Math.max(mediaHeight, readingHeight) >= minimumTravel;
}

export function projectMediaPinHeight({ copyHeight, mediaHeight, viewportHeight, top = 84 }) {
  const readingHeight = Math.max(0, viewportHeight - top - 24);
  // Release as the end of the text enters the reading viewport. Native sticky
  // positioning makes that hand-off continuous in either scroll direction.
  return copyHeight - Math.max(0, readingHeight - mediaHeight);
}
